import { render } from "./ticketQP.vue?vue&type=template&id=ac6b10ca&scoped=true"
import script from "./ticketQP.vue?vue&type=script&lang=js"
export * from "./ticketQP.vue?vue&type=script&lang=js"

import "./ticketQP.vue?vue&type=style&index=0&id=ac6b10ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac6b10ca"

export default script